import React, { Component } from "react";
import actions from '../actions';
import entityActions from '../../../baseApp/entities/actions';
import authActions from '../../../baseApp/auth/actions';
import { connect } from 'react-redux';
import MeetingRoomsPage from '../components/MeetingRoomsPage';
import ObjectUtils from '../../../baseApp/shared/utils/ObjectUtils';

class MeetingRoomsPageContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                name: {
                    value: ""
                },
                parentId: {
                    value: ""
                },
                email: {
                    value: ""
                },
                capacity: {
                    value: ""
                },
                status: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
       // this.props.getUserPageRefresh();
        const { getEntityList } = this.props;
        getEntityList({
            type: ['floor']
        });

        this.mountData();
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }
        this.props.searchMeetingRooms({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    mountData = (currentPage, pageSize, sortProperty, sortDirection) => {
        let {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        if(this.props.location.state?.searchFieldsData !== undefined){
            searchFieldsValues =  this.props.location.state.searchFieldsData;
            this.handleSearchFieldValuesChange(searchFieldsValues);
        }
        if(this.props.location.state?.universalSearchField !== undefined ){
            universalSearchField = this.props.location.state.universalSearchField;
            this.handleUniversalSearchFieldChange(universalSearchField);
        }

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }
        this.props.searchMeetingRooms({
            ...filter,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchFieldValuesChange = (value) => {
        this.setState({
            searchFieldsValues: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

     onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const {
            table:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    handleAddButtonClicked = () => {
        this.props.history.push('/meetingRooms/create');
    };

    handleRowClicked = meetingRoom => {
        
        this.props.history.push({
            pathname: '/meetingRooms/' + meetingRoom.id,
            state: { searchFieldsData : this.state.searchFieldsValues, universalSearchField: this.state.universalSearchField }
          })
        //push('/meetingRooms/' + meetingRoom.id);
    };

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            },
            entityList
        } = this.props;

        return (
            <MeetingRoomsPage
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}
                handleAddButtonClicked={this.handleAddButtonClicked}

                data={data}
                sort={sort}
                totalElements={totalElements}
                entityList={entityList}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onRowClick={this.handleRowClicked}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ meetingRoomsReducer, entitiesReducer }) => {
    return {
        searchFieldsData: meetingRoomsReducer.searchFieldsData,
        entityList: entitiesReducer.entityList,
        table: meetingRoomsReducer.table
    };
};

const mapDispatchToProps = {
    searchMeetingRooms: actions.searchMeetingRooms,
    getEntityList: entityActions.getEntityList,
    //getUserPageRefresh: authActions.getUserPageRefresh,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MeetingRoomsPageContainer);